export const emailTemplatesKeys = {
	all: ['emailTemplates'],
	list: () => ['emailTemplates', 'list'],
	preview: (params) => ['emailTemplates', 'preview', params],
};
